import { normalizeLang } from './normalizeLang';

export interface LangOption { value: string; label: string; }

/**
 * 把主播预选的 allowed_langs 映射成选择器选项:
 * - 保持主播预选顺序
 * - 按 normalizeLang 去重(zh / zh_hans 视为同一项)
 * - 认不出的代码(三端语言表不一致时)用代码本身当 label, 不静默丢弃
 */
export function buildAllowedLangOptions(
  allowedLangs: string[],
  allOptions: LangOption[],
): LangOption[] {
  const seen = new Set<string>();
  const result: LangOption[] = [];
  allowedLangs.forEach((code) => {
    if (!code) return;
    const key = normalizeLang(code);
    if (seen.has(key)) return;
    seen.add(key);
    const opt = allOptions.find((o) => normalizeLang(o.value) === key);
    result.push(opt ?? { value: code, label: code });
  });
  return result;
}
